export default "__VITE_IMAGE_ASSET__1a8faa12__";